"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Taken from ui-common/src/enums, commonEnums, do not export from here
var ChargeSessionCodeType;
(function (ChargeSessionCodeType) {
    ChargeSessionCodeType["DIAGNOSIS"] = "diagnosis";
    ChargeSessionCodeType["PROCEDURE"] = "procedure";
    ChargeSessionCodeType["MODIFIER"] = "modifier";
})(ChargeSessionCodeType || (ChargeSessionCodeType = {}));
var vanillaDiagnosis = {
    id: 1,
    code: "I10",
    original: true,
    codeAssessment: {
        assessment: "IDEAL ICD",
        role: "PAYMENT",
        id: 1
    },
    sequenceNumber: 1,
    codeType: "diagnosis"
};
var vanillaProcedure = {
    id: 2,
    code: "99213",
    original: true,
    codeAssessment: {
        assessment: "IDEAL CPT",
        role: "CODABLE",
        id: 1
    },
    sequenceNumber: 1,
    units: 1,
    codeType: "procedure",
    description: "someDescription"
};
var vanillaModifier = {
    id: 3,
    code: "22",
    original: true,
    codeAssessment: {
        assessment: "IDEAL",
        role: "PAYMENT",
        id: 1
    },
    sequenceNumber: 1,
    codeType: "modifier"
};
var TaskCodeFixtures = {
    vanillaDiagnosis: vanillaDiagnosis,
    vanillaProcedure: vanillaProcedure,
    vanillaModifier: vanillaModifier
};
exports.default = TaskCodeFixtures;
//# sourceMappingURL=CQATaskCodes.js.map